<template>
  <div class="kakao-player-ad-wrapper">
    <div class="kakao-player-ad" ref="adContainer"></div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

const props = defineProps({
  delay: {
    type: Number,
    default: 500
  }
})

const adContainer = ref(null)
let adLoaded = false

const loadAd = () => {
  if (adLoaded || !adContainer.value) return
  adLoaded = true

  // ins 요소 생성
  const ins = document.createElement('ins')
  ins.className = 'kakao_ad_area'
  ins.style.display = 'none'
  ins.setAttribute('data-ad-unit', 'DAN-EsvmornllqbfPSHH')
  ins.setAttribute('data-ad-width', '320')
  ins.setAttribute('data-ad-height', '50')
  adContainer.value.appendChild(ins)

  // 스크립트 생성 및 로드
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = '//t1.daumcdn.net/kas/static/ba.min.js'
  script.async = true
  adContainer.value.appendChild(script)
}

onMounted(() => {
  // 플레이어가 완전히 화면에 나타난 후 광고 로드
  setTimeout(() => {
    loadAd()
  }, props.delay)
})
</script>

<style scoped>
.kakao-player-ad-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  min-height: 66px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin-top: 8px;
}

.kakao-player-ad {
  width: 320px;
  min-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
